<template>
  <div class="login-container">
    <div class="bg-decoration">
      <div class="bg-circle bg-circle-1"></div>
      <div class="bg-circle bg-circle-2"></div>
      <div class="bg-circle bg-circle-3"></div>
    </div>
    
    <div class="login-content">
      <div class="logo-section animate-fade-in-up">
        <div class="logo-wrapper">
          <!-- <div class="logo-icon bounce-animation">🎵</div> -->
          <div class="logo-icon bounce-animation">
            <img src="../assets/微信图片_20260223131335_98_517.jpg" alt="" style="border-radius: 1rem;">
          </div>
        </div>
        <div class="logo-text">
          <h1 class="title-slide-in">音基冒险岛</h1>
          <p class="subtitle-fade-in">测试你的音乐知识</p>
        </div>
      </div>
      
      <div class="slogan-section animate-fade-in-up-delay">
        <div class="slogan-card slogan-slide-in">
          <van-icon name="music-o" size="28" color="#07c160" />
          <span>音乐知识大挑战</span>
        </div>
      </div>
      
      <div class="login-section">
        <div v-if="wxAutoLogging" class="login-loading">
          <van-loading type="spinner" color="#07c160" />
          <span>正在登录...</span>
        </div>
        <div class="login-btn wechat-btn btn-slide-in" :class="{ disabled: wxAutoLogging }" @click="handleWxLogin">
          <div class="btn-icon">
            <van-icon name="wechat" size="28" />
          </div>
          <div class="btn-content">
            <span class="btn-title">微信一键登录</span>
            <span class="btn-desc">快速安全登录</span>
          </div>
          <van-icon name="arrow" size="20" />
        </div>
      </div>
      
      <div class="tips-section tips-fade-in">
        <p class="tips">登录即表示同意</p>
        <div class="agreement-links">
          <a href="#" class="link">《用户协议》</a>
          <span class="separator">和</span>
          <a href="#" class="link">《隐私政策》</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'Login',
  data() {
    return {
      wxAutoLogging: false,
      wxLoginStarted: false
    }
  },
  mounted() {
    const code = this.getUrlParam('code')
    if (code) {
      this.loginWithWechatCode(code, true)
    }
  },
  methods: {
    clearOAuthQuery() {
      const base = window.location.origin + window.location.pathname
      const hash = this.$route.path && this.$route.path !== '/login'
        ? '#' + this.$route.path
        : '#/home'
      window.history.replaceState(null, '', base + hash)
    },
    loginWithWechatCode(code, silent) {
      if (this.wxLoginStarted) {
        return
      }
      this.wxLoginStarted = true
      if (silent) {
        this.wxAutoLogging = true
      }
      this.$store.dispatch('login', code)
        .then(() => {
          this.clearOAuthQuery()
          if (!silent) {
            Toast.success('登录成功')
          }
          this.$router.replace('/home')
        })
        .catch(err => {
          this.wxLoginStarted = false
          this.wxAutoLogging = false
          Toast.fail(err.message || '登录失败')
        })
    },
    handleWxLogin() {
      if (this.wxAutoLogging || this.wxLoginStarted) {
        return
      }
      const code = this.getUrlParam('code')

      if (code) {
        this.loginWithWechatCode(code, false)
      } else {
        const appId = (process.env.VUE_APP_WECHAT_APP_ID || '').trim()
        if (!appId) {
          Toast.fail('未配置公众号 AppID，请在 .env.production 设置 VUE_APP_WECHAT_APP_ID 后重新打包上传')
          return
        }
        const redirectUri = encodeURIComponent(this.getOAuthRedirectUri())
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
        window.location.href = url
      }
    },
    getOAuthRedirectUri() {
      return window.location.href.split('#')[0]
    },
    getUrlParam(name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const r = window.location.search.substr(1).match(reg)
      if (r != null) {
        try {
          return decodeURIComponent(r[2].replace(/\+/g, ' '))
        } catch (e) {
          return r[2]
        }
      }
      return null
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.bg-circle-1 {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -50px;
  animation: float-circle 8s ease-in-out infinite;
}

.bg-circle-2 {
  width: 200px;
  height: 200px;
  bottom: 100px;
  left: -50px;
  animation: float-circle 6s ease-in-out infinite reverse;
}

.bg-circle-3 {
  width: 150px;
  height: 150px;
  bottom: 200px;
  right: 50px;
  animation: float-circle 7s ease-in-out infinite;
  animation-delay: -2s;
}

@keyframes float-circle {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 0.8;
  }
}

.login-content {
  width: 100%;
  max-width: 360px;
  position: relative;
  z-index: 1;
}

.logo-section {
  text-align: center;
  margin-bottom: 40px;
}

.logo-wrapper {
  width: 100px;
  height: 100px;
  margin: 0 auto 24px;
  /* background: white; */
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  animation: logo-pop 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.3s both;
}

.logo-icon {
  font-size: 56px;
}

.logo-text h1 {
  font-size: 32px;
  color: white;
  margin: 0 0 8px 0;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo-text p {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

@keyframes logo-pop {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.bounce-animation {
  animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.animate-fade-in-up {
  animation: fade-in-up 0.8s ease-out both;
}

.animate-fade-in-up-delay {
  animation: fade-in-up 0.8s ease-out 0.2s both;
}

@keyframes fade-in-up {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.title-slide-in {
  animation: title-slide 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.5s both;
}

@keyframes title-slide {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.subtitle-fade-in {
  animation: subtitle-fade 0.5s ease-out 0.7s both;
}

@keyframes subtitle-fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.85;
  }
}

.slogan-section {
  margin-bottom: 32px;
}

.slogan-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.95);
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.slogan-card span {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}

.slogan-slide-in {
  animation: slogan-slide 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.4s both;
}

@keyframes slogan-slide {
  0% {
    transform: scale(0.8) translateY(20px);
    opacity: 0;
  }
  100% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.login-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-btn {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: white;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.login-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.6s ease, height 0.6s ease;
}

.login-btn:active::before {
  width: 300px;
  height: 300px;
}

.login-btn:active {
  transform: scale(0.98);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.login-btn.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.login-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  color: #07c160;
  font-size: 15px;
}

.btn-slide-in {
  animation: btn-slide 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.6s both;
}

@keyframes btn-slide {
  0% {
    transform: translateX(-30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.login-btn .btn-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #07c160 0%, #00a854 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: white;
}

.login-btn .btn-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.login-btn .btn-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
}

.login-btn .btn-desc {
  font-size: 12px;
  color: #8c8c8c;
}

.login-btn .van-icon:last-child {
  color: #ccc;
  font-size: 18px;
}

.wechat-btn .btn-icon {
  background: linear-gradient(135deg, #07c160 0%, #00a854 100%);
}

.wechat-btn:active {
  background: #f5f5f5;
}

.tips-section {
  text-align: center;
  margin-top: 32px;
}

.tips-section .tips {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 8px 0;
}

.tips-fade-in {
  animation: tips-fade 0.6s ease-out 0.9s both;
}

@keyframes tips-fade {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.agreement-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.agreement-links .link {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: underline;
}

.agreement-links .separator {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}
</style>